document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('gift-finder-form');
  if (!form) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const age = form.elements.age?.value.trim();
    const giftType = form.elements.gift_type?.value.trim();
    const budget = form.elements.budget?.value.trim();

    if (!giftType) {
      alert('Please select a gift type.');
      return;
    }

    const params = new URLSearchParams();

    // --- AGE filter ---
    if (age) {
      params.append('filter.p.m.custom.age_group', age.replace(/_/g, ' '));
    }

    // --- BUDGET / PRICE filter ---
    if (budget) {
      // Handle formats like: under_2500, 2500_to_5000, over_5000
      if (budget.includes('_to_')) {
        const [min, max] = budget.split('_to_');
        params.append('filter.v.price.gte', min);
        params.append('filter.v.price.lte', max);
      } else if (budget.startsWith('under_')) {
        const max = budget.replace('under_', '');
        params.append('filter.v.price.lte', max);
      } else if (budget.startsWith('over_')) {
        const min = budget.replace('over_', '');
        params.append('filter.v.price.gte', min);
      } else {
        // fallback for any other value format
        const numbers = budget.match(/\d+/g);
        if (numbers && numbers.length === 2) {
          params.append('filter.v.price.gte', numbers[0]);
          params.append('filter.v.price.lte', numbers[1]);
        } else if (numbers && numbers.length === 1) {
          params.append('filter.v.price.lte', numbers[0]);
        }
      }
    }

    // --- Redirect ---
    const query = params.toString();
    const targetUrl = `/collections/${giftType}?${query}`;

    if (
      window.location.pathname.includes(`/collections/${giftType}`) &&
      typeof FacetFiltersForm !== 'undefined'
    ) {
      FacetFiltersForm.renderPage(query, null, true);
      document.querySelector('#ProductGridContainer')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = targetUrl;
    }
  });

  // --- Preselect filters from URL ---
  const params = new URLSearchParams(window.location.search);
  const ageParam = params.get('filter.p.m.custom.age_group');
  const budgetLte = params.get('filter.v.price.lte');
  const budgetGte = params.get('filter.v.price.gte');

  // Age restore
  if (ageParam && form.elements.age) {
    const formatted = ageParam.replace(/ /g, '_');
    const option = [...form.elements.age.options].find(o => o.value === formatted);
    if (option) option.selected = true;
  }

  // Budget restore
  if (form.elements.budget && (budgetLte || budgetGte)) {
    let selectedValue = '';
    if (budgetLte && budgetGte) selectedValue = `${budgetGte}_to_${budgetLte}`;
    else if (budgetLte) selectedValue = `under_${budgetLte}`;
    else if (budgetGte) selectedValue = `over_${budgetGte}`;

    const option = [...form.elements.budget.options].find(o => o.value === selectedValue);
    if (option) option.selected = true;
  }
});
